import { useAtomValue } from "jotai";
import { userDataState } from "@/lib/store";
import { isOrtexApp } from "@/lib/utils";
import { TRADING_BUILD_ENABLED, TradingAccess, TradingAccessUser, tradingAccess } from "@/lib/trading/access";

/**
 * The trading access rule (see `access.ts`) for the signed-in user, from the `/API/v2/user`
 * payload already in `userDataState`. `pending` until that payload arrives.
 */
export function useTradingAccess(): TradingAccess {
    const userData = useAtomValue(userDataState) as TradingAccessUser | null | undefined;
    return tradingAccess({ buildEnabled: TRADING_BUILD_ENABLED, nativeApp: isOrtexApp(), userData });
}

/**
 * For surfaces outside the trading pages (the Trading menu entry, the buying-power strip in the
 * header): true only once access is confirmed, so they never appear while the answer is pending.
 */
export function useTradingVisible(): boolean {
    return useTradingAccess() === "allowed";
}
